import "./application.css"
import "@hotwired/turbo-rails"
import { Application } from "@hotwired/stimulus"

const application = Application.start()
application.debug = false
window.Stimulus = application

// Same eager-load behavior as stimulus-rails' importmap helper, expressed in
// Vite's native vocabulary. Drop a `*_controller.js` into app/javascript/controllers/
// and it auto-registers — including nested folders (foo/bar_controller.js → "foo--bar").
const controllerModules = import.meta.glob("../controllers/**/*_controller.js", { eager: true })
for (const path in controllerModules) {
  const name = path
    .replace(/^.*\/controllers\//, "")
    .replace(/_controller\.js$/, "")
    .replace(/\//g, "--")
  application.register(name, controllerModules[path].default)
}

export { application }
